import { render, staticRenderFns } from "./NewCompany.vue?vue&type=template&id=6a21259d&scoped=true&"
import script from "./NewCompany.vue?vue&type=script&lang=js&"
export * from "./NewCompany.vue?vue&type=script&lang=js&"
import style0 from "./NewCompany.vue?vue&type=style&index=0&id=6a21259d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a21259d",
  null
  
)

export default component.exports